var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f9f9f9",
  d: "M0 0h16v16H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M15.418 3.366c.777-.778.773-2.02.005-2.789a1.967 1.967 0 0 0-2.789.005L8 5.217 3.366.582A1.966 1.966 0 0 0 .577.577a1.967 1.967 0 0 0 .005 2.789L5.217 8 .582 12.634a1.966 1.966 0 0 0-.005 2.789 1.967 1.967 0 0 0 2.789-.005L8 10.783l4.634 4.635c.778.777 2.02.773 2.789.005a1.967 1.967 0 0 0-.005-2.789L10.783 8z"
}))));
export default SvgX;